/* eslint-disable max-len */
import React from 'react'

import compose from 'recompose/compose'
import Expandable from '../../Expandable/Expandable'
import EmailSettings from './EmailSettings'
import { connect as connectStaticText } from '../../StaticText/connect'
import { COMMUNICATION_SETTINGS } from '../../../services/url/constants'

const CommunicationSettings = (props) => {
  const { staticText } = props
  return (
    <Expandable
      id={COMMUNICATION_SETTINGS}
      className="my-account-settings-V2__settings-container"
      variant="setting"
      header={staticText.getIn(['data', 'communicationsHeader'])}
      description={staticText.getIn(['data', 'communicationsBody'])}
    >
      <EmailSettings />
    </Expandable>
  )
}

export default compose(connectStaticText({ storeKey: 'myAccountSettingsV2' }))(CommunicationSettings)
